<template>
  <div>
    <section class="main">
      <div class="figuras">
        <div class="container">
          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-12">
              <div
                class="
                  row
                  d-flex
                  justify-content-center
                  align-items-center
                  mb-4
                "
              >
                <div class="col-5 text-center">
                  <img
                    class="img-fluid"
                    src="../assets/imgs/mdlp2021/logo-maestros-de-la-parrilla.png"
                    alt="Maestros de la Parrilla en Línea"
                  />
                </div>
              </div>

              <div class="row">
                <h1
                  class="white col-12 fXG text-center naranja"
                  v-show="this.paso == 1"
                >
                  Crea tu cuenta
                </h1>
                <p class="fG white col-12 text-md-center">
                  Para <strong>crear tu cuenta</strong>, por favor ingresa los
                  siguientes datos:
                </p>
                <h1
                  class="white col-12 fXG text-center"
                  v-show="this.paso == 2"
                >
                  Verificación
                </h1>
              </div>

              <div class="row pb-3">
                <div
                  class="formulario col-12 col-lg-6 offset-lg-3 pt-2 pb-4"
                  v-show="this.paso == 1"
                >
                  <form method="post" @submit="submitFormulario($event)">
                    <label>
                      <span class="naranja fG">Nombre*</span>
                      <input
                        type="text"
                        v-model="form.nombre"
                        maxlength="100"
                        placeholder="Nombre"
                        required
                      />
                    </label>

                    <label>
                      <span class="naranja fG">Apellido*</span>
                      <input
                        type="text"
                        v-model="form.apellidos"
                        maxlength="100"
                        placeholder="Apellido"
                        required
                      />
                    </label>

                    <label>
                      <span class="naranja fG">Email*</span>
                      <input
                        type="email"
                        id="email"
                        v-model="form.email"
                        maxlength="100"
                        placeholder="Email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        title="Captura un email válido"
                        required
                      />
                    </label>

                    <label>
                      <span class="naranja fG">Teléfono*</span>
                      <input
                        type="tel"
                        v-model="form.telefono"
                        id="telefono"
                        maxlength="10"
                        placeholder="Teléfono"
                        required
                      />
                    </label>

                    <label>
                      <span class="naranja fG">Contraseña*</span>
                      <input
                        type="password"
                        v-model="form.password"
                        maxlength="100"
                        placeholder="Contraseña"
                        required
                      />
                    </label>

                    <label>
                      <span class="naranja fG">Confirmar contraseña*</span>
                      <input
                        type="password"
                        v-model="form.password2"
                        maxlength="100"
                        placeholder="Confirmar contraseña"
                        required
                      />
                    </label>

                    <div class="pb-3">
                      <span class="naranja fG">Fecha de Nacimiento*</span>
                      <div class="d-flex">
                        <select
                          class="w-100 mx-2 fG"
                          v-model="form.dia"
                          required
                        >
                          <option value="">Día</option>
                          <option value="01">1</option>
                          <option value="02">2</option>
                          <option value="03">3</option>
                          <option value="04">4</option>
                          <option value="05">5</option>
                          <option value="06">6</option>
                          <option value="07">7</option>
                          <option value="08">8</option>
                          <option value="09">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                          <option value="13">13</option>
                          <option value="14">14</option>
                          <option value="15">15</option>
                          <option value="16">16</option>
                          <option value="17">17</option>
                          <option value="18">18</option>
                          <option value="19">19</option>
                          <option value="20">20</option>
                          <option value="21">21</option>
                          <option value="22">22</option>
                          <option value="23">23</option>
                          <option value="24">24</option>
                          <option value="25">25</option>
                          <option value="26">26</option>
                          <option value="27">27</option>
                          <option value="28">28</option>
                          <option value="29">29</option>
                          <option value="30">30</option>
                          <option value="31">31</option>
                        </select>

                        <select
                          class="w-100 mx-2 fG"
                          v-model="form.mes"
                          required
                        >
                          <option value="">Mes</option>
                          <option value="01">1</option>
                          <option value="02">2</option>
                          <option value="03">3</option>
                          <option value="04">4</option>
                          <option value="05">5</option>
                          <option value="06">6</option>
                          <option value="07">7</option>
                          <option value="08">8</option>
                          <option value="09">9</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                        </select>

                        <select
                          class="w-100 mx-2 fG"
                          v-model="form.ano"
                          required
                        >
                          <option value="">Año</option>
                          <option value="1930">1930</option>
                          <option value="1931">1931</option>
                          <option value="1932">1932</option>
                          <option value="1933">1933</option>
                          <option value="1934">1934</option>
                          <option value="1935">1935</option>
                          <option value="1936">1936</option>
                          <option value="1937">1937</option>
                          <option value="1938">1938</option>
                          <option value="1939">1939</option>
                          <option value="1940">1940</option>
                          <option value="1941">1941</option>
                          <option value="1942">1942</option>
                          <option value="1943">1943</option>
                          <option value="1944">1944</option>
                          <option value="1945">1945</option>
                          <option value="1946">1946</option>
                          <option value="1947">1947</option>
                          <option value="1948">1948</option>
                          <option value="1949">1949</option>
                          <option value="1950">1950</option>
                          <option value="1951">1951</option>
                          <option value="1952">1952</option>
                          <option value="1953">1953</option>
                          <option value="1954">1954</option>
                          <option value="1955">1955</option>
                          <option value="1956">1956</option>
                          <option value="1957">1957</option>
                          <option value="1958">1958</option>
                          <option value="1959">1959</option>
                          <option value="1960">1960</option>
                          <option value="1961">1961</option>
                          <option value="1962">1962</option>
                          <option value="1963">1963</option>
                          <option value="1964">1964</option>
                          <option value="1965">1965</option>
                          <option value="1966">1966</option>
                          <option value="1967">1967</option>
                          <option value="1968">1968</option>
                          <option value="1969">1969</option>
                          <option value="1970">1970</option>
                          <option value="1971">1971</option>
                          <option value="1972">1972</option>
                          <option value="1973">1973</option>
                          <option value="1974">1974</option>
                          <option value="1975">1975</option>
                          <option value="1976">1976</option>
                          <option value="1977">1977</option>
                          <option value="1978">1978</option>
                          <option value="1979">1979</option>
                          <option value="1980">1980</option>
                          <option value="1981">1981</option>
                          <option value="1982">1982</option>
                          <option value="1983">1983</option>
                          <option value="1984">1984</option>
                          <option value="1985">1985</option>
                          <option value="1986">1986</option>
                          <option value="1987">1987</option>
                          <option value="1988">1988</option>
                          <option value="1989">1989</option>
                          <option value="1990">1990</option>
                          <option value="1991">1991</option>
                          <option value="1992">1992</option>
                          <option value="1993">1993</option>
                          <option value="1994">1994</option>
                          <option value="1995">1995</option>
                          <option value="1996">1996</option>
                          <option value="1997">1997</option>
                          <option value="1998">1998</option>
                          <option value="1999">1999</option>
                          <option value="2000">2000</option>
                          <option value="2001">2001</option>
                          <option value="2002">2002</option>
                          <option value="2003">2003</option>
                          <option value="2004">2004</option>
                          <option value="2005">2005</option>
                          <option value="2006">2006</option>
                          <option value="2007">2007</option>
                          <option value="2008">2008</option>
                          <option value="2009">2009</option>
                          <option value="2010">2010</option>
                          <option value="2011">2011</option>
                          <option value="2012">2012</option>
                          <option value="2013">2013</option>
                          <option value="2014">2014</option>
                          <option value="2015">2015</option>
                          <option value="2016">2016</option>
                          <option value="2017">2017</option>
                          <option value="2018">2018</option>
                          <option value="2019">2019</option>
                          <option value="2020">2020</option>
                          <option value="2021">2021</option>
                        </select>
                      </div>
                    </div>

                    <label class="m-0">
                      <span class="naranja fG">Estado*</span>
                      <select class="fG" v-model="form.estado" required>
                        <option value>Estado</option>
                        <option value="Aguascalientes">Aguascalientes</option>
                        <option value="Baja California">Baja California</option>
                        <option value="Baja California Sur">
                          Baja California Sur
                        </option>
                        <option value="Campeche">Campeche</option>
                        <option value="Chiapas">Chiapas</option>
                        <option value="Chihuahua">Chihuahua</option>
                        <option value="CDMX">Ciudad de México</option>
                        <option value="Coahuila">Coahuila</option>
                        <option value="Colima">Colima</option>
                        <option value="Durango">Durango</option>
                        <option value="Estado de México">
                          Estado de México
                        </option>
                        <option value="Guanajuato">Guanajuato</option>
                        <option value="Guerrero">Guerrero</option>
                        <option value="Hidalgo">Hidalgo</option>
                        <option value="Jalisco">Jalisco</option>
                        <option value="Michoacán">Michoacán</option>
                        <option value="Morelos">Morelos</option>
                        <option value="Nayarit">Nayarit</option>
                        <option value="Nuevo León">Nuevo León</option>
                        <option value="Oaxaca">Oaxaca</option>
                        <option value="Puebla">Puebla</option>
                        <option value="Querétaro">Querétaro</option>
                        <option value="Quintana Roo">Quintana Roo</option>
                        <option value="San Luis Potosí">San Luis Potosí</option>
                        <option value="Sinaloa">Sinaloa</option>
                        <option value="Sonora">Sonora</option>
                        <option value="Tabasco">Tabasco</option>
                        <option value="Tamaulipas">Tamaulipas</option>
                        <option value="Tlaxcala">Tlaxcala</option>
                        <option value="Veracruz">Veracruz</option>
                        <option value="Yucatán">Yucatán</option>
                        <option value="Zacatecas">Zacatecas</option>
                      </select>
                    </label>

                    <label class="pt-3 white">
                      <input
                        type="checkbox"
                        class="mr-2 fG"
                        placeholder="Confirmar contraseña"
                        required
                      />
                      He leído y acepto los
                      <a
                        class="naranja"
                        target="_blank"
                        href="https://www.walmartmexico.com/media-library/document/aviso-de-privacidad-integral-de-e-commerce-y-centro-de-atencion-a-clientes/_proxyDocument?id=0000016f-f772-d8a0-a57f-fffa3a020000"
                        >Términos y Condiciones</a
                      >
                      y el
                      <a
                        class="naranja"
                        target="_blank"
                        href="https://www.superama.com.mx/informacion/aviso-de-privacidad"
                        >Aviso de Privacidad</a
                      >
                    </label>

                    <div class="d-flex py-3">
                      <div class="col-6">
                        <div class="row">
                          <div class="col-12 fG">
                            <router-link to="/" class="gris"
                              >¿Ya tienes cuenta? Ingresa aquí.</router-link
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="text-center pt-2">
                          <button type="submit" class="submit btn btnsup w-100">
                            Registrarme
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div
                  class="formulario col-12 col-lg-6 offset-lg-3 pt-2 pb-4"
                  v-show="this.paso == 2"
                >
                  <form method="post" @submit="submitVerificacion($event)">
                    <label>
                      <input
                        type="text"
                        v-model="form2.codigo"
                        maxlength="100"
                        placeholder="Código de verificación"
                        required
                      />
                    </label>

                    <div class="row py-3">
                      <div class="col-6">
                        <!-- <div class="row">
                          <div class="col-12">
                            <router-link to="/" class="gris">¿Ya tienes cuenta? Ingresa aquí.</router-link>
                          </div>
                        </div>-->
                      </div>
                      <div class="col-6">
                        <div class="text-center pt-2">
                          <button type="submit" class="submit btn btnsup w-100">
                            Verificar
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>

      <div v-if="arktrid != '' && user_id != ''">
        <img
          :src="'https://ads.go2perseo.com/trk_o?px=HmHynm7O90U%3d&adv_sub='+user_id"
          width="1"
          height="1"
        />
        <img
          :src="'https://prs.arkeero.net/trk_o?px=HmHynm7O90U%3d&adv_sub='+user_id"
          width="1"
          height="1"
        />
        <img
          src="https://sp.analytics.yahoo.com/spp.pl?a=10000&.yp=10153717&js=no&ec=MaParrillaConversion"
        />
        <img
          src="https://sp.analytics.yahoo.com/spp.pl?a=10000&.yp=10153718&he={INSERT_MACRO_HERE}&ec=MaParrillaConversion"
        />
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Footer from "../Components/Footer.vue";
import Datepicker from "vuejs-datepicker";

export default {
  name: "AcademiaDigital",
  props: {
    msg: String,
  },
  data() {
    return {
      paso: 1,
      codigo_de_verificacion: -1,
      form: {
        nombre: "",
        apellidos: "",
        email: "",
        telefono: "",
        password: "",
        password2: "",
        fecha: "",
        dia: "",
        mes: "",
        ano: "",
        estado: "",
      },
      form2: {
        email: "",
        codigo: "",
      },
      arktrid: "",
      user_id: ""
    };
  },
  mounted: function () {


    ////this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.$cookie.delete("usersupmdlp");
    this.$cookie.delete("useracademiadigital");

    /*this.$store.state.user = JSON.parse(
      localStorage.getItem("useracademiadigital")
    );*/
    AOS.init();

    try {
      if (
        this.$route.query.arktrid != undefined &&
        this.$route.query.arktrid != ""
      )
        this.arktrid = this.$route.query.arktrid;
    } catch (e) {
      //algo
      this.arktrid = "";
    }

    // if (this.$store.state.user != null) {
    //   if (this.$store.state.user.email != "") {
    //     this.$router.push("/dashboard");
    //   }
    // }
  },
  components: {
    "footer-mx": Footer,
  },
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      if (this.form.telefono.length == 10 && !isNaN(this.form.telefono)) {
        if (this.form.password.length >= 8) {
          if (this.form.password == this.form.password2) {


            window.fbq('track', 'BotonRegistro', {producto : "mdlp", seccion: "registro"});

            const https = require("https");

            vm.$store.state.loading = true;

            var fecha = "";
            // fecha = new Date(fecha);
            // var dia = ("0" + fecha.getDate()).slice(-2);
            // var mes = ("0" + (fecha.getMonth() + 1)).slice(-2);
            // var ano = fecha.getFullYear();

            fecha = this.form.dia + "/" + this.form.mes + "/" + this.form.ano;

            var qData = {
              nombre: this.form.nombre,
              apellido: this.form.apellidos,
              email: this.form.email,
              telefono: this.form.telefono,
              password: this.form.password,
              fecha_de_nacimiento: fecha,
              estado: this.form.estado,
              arkeero: this.arktrid,
            };

            let formData = new FormData();
            formData.append("form_data", JSON.stringify(qData));

            console.log("enviando");
            //console.log(JSON.stringify(qData));

            this.$http
              .post(
                this.$store.state.baseurl + "alta-usuario-auto-ark.php",
                formData,
                {
                  emulateJSON: true,
                  httpsAgent: new https.Agent({ rejectUnauthorized: false }),
                  headers: {
                    "Content-Type": "multipart/form-data",
                    //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
                  },
                }
              )
              .then(
                (response) => {
                  // get body data
                  console.log("envio");
                  //console.log(response);

                  //console.log(response.data);
                  var res = response.data;

                  if (res.status == "ok") {

                    window.fbq('track', 'CompleteRegistration', {producto : "mdlp", seccion: "registro"});
                    
                    if (this.arktrid != "") {
                      this.user_id = res.user.id;
                      this.enviarPixel(res.msg, res.user);
                    } else {
                      vm.$store.state.loading = false;
                      swal
                        .fire({
                          title: "Registro",
                          text: res.msg,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: `Ok`,
                          icon: "success",
                        })
                        .then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          this.$router.push("/");
                        });
                    }

                    this.$gtag.event("Registro en aplicación", {
                      event_category: "MDLP",
                    });
                  } else if (res.status == "notok") {
                    swal.fire("Oops", res.msg, "warning");
                  }
                },
                (error) => {
                  // error callback
                  console.log("error callback");
                  console.log(error);
                  vm.$store.state.loading = false;
                  //console.log(userData);
                  swal.fire(
                    "Oops",
                    "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
                    "warning"
                  );
                }
              );
          } else {
            swal.fire("Oops", "Las contraseñas no coinciden.", "warning");
          }
        } else {
          swal.fire(
            "Oops",
            "La contraseña debe tener al menos 8 caracteres.",
            "warning"
          );
        }
      } else {
        swal.fire("Oops", "Captura un teléfono válido.", "warning");
      }
    },
    enviarPixel(msg, user) {
      console.log("registrando arktrid");

      var vm = this;
      const https = require("https");

      var qData = {};

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      let user_id = user.id;

      let url =
        "https://prs.arkeero.net/trk_o?adv_sub=" +
        user_id.toString() +
        "&trid=" +
        this.arktrid;

      this.$http
        .post(url, formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            console.log(response);
            //var res = response.data;

            swal
              .fire({
                title: "Registro",
                text: msg,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `Ok`,
                icon: "success",
              })
              .then((result) => {
                /* Read more about isConfirmed, isDenied below */
                this.$router.push("/");
              });
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            console.log(error);
            swal
              .fire({
                title: "Registro",
                text: msg,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `Ok`,
                icon: "success",
              })
              .then((result) => {
                /* Read more about isConfirmed, isDenied below */
                this.$router.push("/");
              });
          }
        );
    },
    submitVerificacion(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        email: this.form.email,
        codigo_de_verificacion: this.form2.codigo,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      //console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "alta-verificacion.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            //console.log(response);
            this.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              //this.$store.state.user = this.$cookie.get("useracademiadigital");

              // localStorage.setItem("useracademiadigital", JSON.stringify(res.user));
              // this.$store.state.user = JSON.stringify(res.user);

              localStorage.setItem("useracademiadigital", JSON.stringify(res.user));
              this.$store.state.user = JSON.stringify(res.user);

              this.$gtag.event("Verificó cuenta", {
                event_category: "MDLP",
              });
              this.$gtag.event("Login en aplicación", {
                event_category: "MDLP",
              });

              this.$router.push("/dashboard");
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
  },
};
</script>

